import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { Datacomm } from '../../core/models/datacomm.model';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
@Injectable({
    providedIn: 'root'
  })
  export class datacommService {
    private apiUrls: { [key in 'bank' | 'pgl' | 'smt']: string } = {
      bank: environment.apiBankUrl, 
      pgl: environment.apiPglUrl,
      smt: environment.apiSmtUrl,
    };
    private getBaseUrl(): string {
      const userType = this.getUserType();
      return this.apiUrls[userType??'smt']+'/datacomm/';
    }
    private getUserType(): 'bank' | 'pgl' | 'smt' {
      const token = localStorage.getItem('x-access-token') || ''; // Fallback to an empty string if null
      if (!token) return 'smt';
  
      try {
        const decodedToken: any = jwtDecode(token);
        return decodedToken.type as 'bank' | 'pgl' | 'smt';
      } catch (error) {
        console.error('Error decoding token:', error);
        return 'smt';
      }
    } 
    headers = new HttpHeaders().set('Content-Type', 'application/json',);
    currentUser = {};
    window: any;
    private datas: Datacomm[] = [];
  public datacomm$ = new Subject<Datacomm[]>();
    constructor(
      private http: HttpClient,
      public router: Router
    ) { }
  
    createdata(datacomm: any[]) {
      
      return new Promise((resolve, reject) => {
        const baseUrl = this.getBaseUrl();
        this.http.post(`${baseUrl}`, datacomm).subscribe(
          (response) => {
            resolve(response);
          },
          (error) => {
            reject(error);
          }
        );
      });
    }

getmanyinfo(compte: any) 
{
  return new Promise((resolve, reject) => {
    const baseUrl = this.getBaseUrl();
    this.http.post(`${baseUrl}filtermanycommid/`, { compte }).subscribe(
        (response) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
    );
  })
}
  }